// extracted by mini-css-extract-plugin
export default {"date":"Time-module__date--4cec"};